var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEarnStaking = function SvgEarnStaking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Earn_Staking_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.624 20.725a1.14 1.14 0 0 1-1.14-1.14v-6.31c.001-.3.12-.587.33-.8.11-.089.236-.157.37-.2a1 1 0 0 1 .44-.08.55.55 0 0 1 .41.08.59.59 0 0 1 .13.18.59.59 0 0 1-.54.81v6.25h17.33v-6.24h-.07a.48.48 0 0 1-.32-.15.58.58 0 0 1-.17-.41.668.668 0 0 1 0-.24.5.5 0 0 1 .17-.2.58.58 0 0 1 .41-.17c.303.002.593.12.81.33.211.213.33.5.33.8v6.28a1.14 1.14 0 0 1-1.14 1.14l-17.35.07Z",
    fill: "#D1B896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.484 7.865a7.74 7.74 0 0 0-11.34-3.34 7.67 7.67 0 0 0-2.86 3.34 7.71 7.71 0 0 0 1 8h-1a.41.41 0 0 0-.22 0 .5.5 0 0 0-.19.13.59.59 0 0 0-.13.63c.034.07.078.133.13.19a.47.47 0 0 0 .19.12.54.54 0 0 0 .22.05h14.1a.58.58 0 0 0 .41-.99.5.5 0 0 0-.19-.13.54.54 0 0 0-.22 0h-.9a7.76 7.76 0 0 0 1-8Zm-3.31 3.3a.57.57 0 0 1 0 .22.528.528 0 0 1-.13.2l-3.28 3.28a.65.65 0 0 1-.38.13.69.69 0 0 1-.41-.17l-3.37-3.28a.54.54 0 0 1-.1-.2.55.55 0 0 1 0-.22.81.81 0 0 1 0-.22.5.5 0 0 1 .13-.19l3.25-3.28a.551.551 0 0 1 .41-.16.62.62 0 0 1 .23 0c.072.03.136.075.19.13l3.28 3.28a.64.64 0 0 1 .13.19.41.41 0 0 1 0 .29h.05Z",
    fill: "#2F5EA7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Earn_Staking_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2.484 3.275)",
    d: "M0 0h19.63v17.45H0z"
  })))));
};
export default SvgEarnStaking;